/**
 *
 * @param state
 * @param action    {
 *     type: 'MY_ACTION',
 *     payload: {}
 * }
 * @returns {{values}}
 */
export default function reducer(state, action) {
    const {
        values,
        ...rest
    } = {...state};

    /**
     * Example payload object:
     *
     * payload: {
     *     field: {},
     *     value: {
     *         text: 'Hello world'
     *     },
     *     answerIndex: "0_1"
     * }
     */
    const payload = action.payload;

    function getPreviousAnswer() {
        return values[payload.field.id] && values[payload.field.id][payload.answerIndex] ? values[payload.field.id][payload.answerIndex] : undefined;
    }

    switch (action.type) {
        case "UPDATE_ANSWER": {
            const previousAnswer = getPreviousAnswer();

            if (previousAnswer) {
                previousAnswer.value = payload.value;
            } else {
                values[payload.field.id] = {
                    ...values[payload.field.id],
                    [payload.answerIndex]: {
                        "value": payload.value
                    }
                };
            }

            return {
                values,
                ...rest,
            }
        }
        case "APPEND_ANSWER": {
            const previousAnswer = getPreviousAnswer();

            if (previousAnswer) {
                previousAnswer.value = {
                    ...previousAnswer.value,
                    ...payload.value
                };
            } else {
                values[payload.field.id] = {
                    ...values[payload.field.id],
                    [payload.answerIndex]: {
                        "value": payload.value
                    }
                };
            }

            return {
                values,
                ...rest,
            }
        }

        case "APPEND_TO_PROPERTY": {
            const previousAnswer = getPreviousAnswer();

            if (previousAnswer) {
                previousAnswer[payload.property] = {
                    ...previousAnswer[payload.property],
                    ...payload.value
                };
            } else {
                values[payload.field.id] = {
                    ...values[payload.field.id],
                    [payload.answerIndex]: {
                        [payload.property]: {
                            [payload.value]: [payload.value]
                        }
                    }
                };
            }

            return {
                values,
                ...rest,
            }
        }

        case "APPEND_TO_VALUE_PROPERTY": {
            const previousAnswer = getPreviousAnswer();

            if (previousAnswer) {
                previousAnswer.value[payload.property] = {
                    ...previousAnswer.value[payload.property],
                    ...{
                        [payload.value]: payload.value
                    }
                };
            } else {
                values[payload.field.id] = {
                    ...values[payload.field.id],
                    [payload.answerIndex]: {
                        ['value']: {
                            [payload.property]: {
                                [payload.value]: [payload.value]
                            }
                        }
                    }
                };
            }

            return {
                values,
                ...rest,
            }
        }

        case 'DELETE_VALUE': {
            const previousAnswer = values[payload.field.id] ? values[payload.field.id] : undefined;

            if (previousAnswer) {
                delete values[payload.field.id][payload.answerIndex];
            }

            return {
                values,
                ...rest,
            }
        }

        case 'DELETE_ANSWER': {
            const previousAnswer = values[payload.field.id] ? values[payload.field.id] : undefined;

            if (previousAnswer) {
                delete values[payload.field.id][payload.answerIndex].value[Object.keys(payload.value)[0]];
            }

            return {
                values,
                ...rest,
            }
        }

        case 'DELETE_VALUE_PROPERTY_ENTRY': {
            const previousAnswer = getPreviousAnswer();

            if (previousAnswer) {
                delete values[payload.field.id][payload.answerIndex].value[payload.property][payload.value];
            }

            return {
                values,
                ...rest,
            }
        }

        case 'SET_VISIBLE': {
            const previousAnswer = getPreviousAnswer();

            if (previousAnswer) {
                previousAnswer.visible = true;
            } else {
                values[payload.field.id] = {
                    ...values[payload.field.id],
                    [payload.answerIndex]: {
                        "visible": true
                    }
                };
            }

            return {
                values,
                ...rest,
            }
        }

        case 'SET_HIDDEN': {
            const previousAnswer = getPreviousAnswer();

            if (previousAnswer) {
                previousAnswer.visible = false;
            } else {
                values[payload.field.id] = {
                    ...values[payload.field.id],
                    [payload.answerIndex]: {
                        "visible": false
                    }
                };
            }

            return {
                values,
                ...rest,
            }
        }

        case 'SET_REQUIRED': {
            const previousAnswer = getPreviousAnswer();

            if (previousAnswer) {
                previousAnswer.required = true;
            } else {
                values[payload.field.id] = {
                    ...values[payload.field.id],
                    [payload.answerIndex]: {
                        "required": true
                    }
                };
            }

            return {
                values,
                ...rest,
            }
        }

        case 'SET_OPTIONAL': {
            const previousAnswer = getPreviousAnswer();

            if (previousAnswer) {
                previousAnswer.required = false;
            } else {
                values[payload.field.id] = {
                    ...values[payload.field.id],
                    [payload.answerIndex]: {
                        "required": false
                    }
                };
            }

            return {
                values,
                ...rest,
            }
        }

        case "APPEND_FIELD_VALUE": {
            values[payload.field.id] = {
                ...values[payload.field.id],
                [payload.answerIndex]: payload.value
            };

            return {
                values,
                ...rest,
            }
        }

        case "START_SUBMIT": {
            return {
                ...state,
                submitting: true,
            }
        }

        case "FINISH_SUBMIT": {
            return {
                ...state,
                submitting: false,
            }
        }

        case "SET_SUBMITTED": {
            return {
                ...state,
                submitted: true,
            }
        }

        case "RESTART_FORM": {
            const {
                values,
                ...rest
            } = state;
            return {
                ...rest,
                values: {
                    ...payload.submission
                },
                submitted: false,
            }
        }

        case "SET_ERROR": {
            const previousAnswer = getPreviousAnswer();

            if (previousAnswer) {
                previousAnswer.errors = payload.value;
            } else {
                values[payload.field.id] = {
                    ...values[payload.field.id],
                    [payload.answerIndex]: {
                        "errors": payload.value
                    }
                };
            }

            return {
                values,
                ...rest,
            }
        }

        case "CLEAR_ERROR": {
            const previousAnswer = getPreviousAnswer();

            if (previousAnswer) {
                previousAnswer.errors = undefined;
            } else {
                values[payload.field.id] = {
                    ...values[payload.field.id],
                    [payload.answerIndex]: {
                        "errors": undefined
                    }
                };
            }

            return {
                values,
                ...rest,
            }
        }

        default: {
            return state;
        }
    }
}